import { FactoryProvider, InjectionToken } from '@angular/core';

import { Storage } from './storage';
import { isSupported } from './is-supported';
import { InMemoryStorage } from './in-memory-storage';

export const STORAGE_TOKEN = new InjectionToken<Storage>('Storage');

export const StorageProvider: FactoryProvider = {
  provide: STORAGE_TOKEN,
  useFactory(): Storage {
    try {
      if (isSupported(localStorage)) {
        return localStorage;
      }
    } catch (error) { }

    return new InMemoryStorage();
  },
};
